import { z } from 'zod';
export const userNotificationSettingsOrganisationSchema = z.object({
    organisationId: z.uuid(),
    weeklyEmail: z.boolean(),
    emailOnMention: z.boolean(),
    emailOnAssignment: z.boolean(),
    emailOnQuoteResponse: z.boolean(),
    emailOnPaymentPlan: z.boolean(),
    emailOnInboundMessages: z.boolean(),
    emailOnPromiseBroken: z.boolean(),
    emailOnQueries: z.boolean(),
});
export const updateUserNotificationSettingsRequestSchema = z.object({
    organisations: z.array(userNotificationSettingsOrganisationSchema),
}).superRefine((value, ctx) => {
    const uniqueOrgIds = new Set(value.organisations.map(org => org.organisationId));
    if (uniqueOrgIds.size !== value.organisations.length) {
        ctx.addIssue({
            code: `custom`,
            path: [`organisations`],
            message: `organisationId values must be unique`,
        });
    }
});
//# sourceMappingURL=user.js.map